import { render, staticRenderFns } from "./EarnedPoint.vue?vue&type=template&id=575a69ee&"
import script from "./EarnedPoint.vue?vue&type=script&lang=js&"
export * from "./EarnedPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports